import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";

const CampaignPlanning = ({ brandId }) => {
    const { accessToken, role } = useAuth();
    const [CampaignPlanning, setCampaignPlanning] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];
    const fetchCampaignPlanning = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/brand-CampaignPlanning/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            setCampaignPlanning(response.data);
        } catch (err) {
            console.error("Error fetching brand overview:", err);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (brandId) {
            fetchCampaignPlanning();
        }
    }, [brandId, accessToken]);

    const handleEditClick = () => {
        setEditDialogVisible(true);
    };

    const handleCampaignPlanningChange = (e) => {
        const { name, value } = e.target;
        setCampaignPlanning((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        setSubmitLoading(true); // Start loading
        try {
            const response = await axios.put(
                `${config.apiBASEURL}/BrandBookRoutes/brand-CampaignPlanning/${CampaignPlanning.campaign_id}/${brandId}`,
                CampaignPlanning,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchCampaignPlanning();
                }, 5000);
            }
        } catch (error) {
            console.error("Error updating brand overview:", error);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false); // Stop loading
        }
    };


    if (loading) return <p>Loading...</p>;
    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">
                    <div>
                        Campaign Planning & Execution
                        <small className="text-danger d-block mt-1" style={{fontSize: '12px'}}>
                            Last Update: {CampaignPlanning?.updatedAt ? new Date(CampaignPlanning.updatedAt).toLocaleString('en-GB') : 'N/A'}
                        </small>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <small className="text-warning ">
                            {allowedRoles.includes(role) && (
                                <Button
                                    title="Edit"
                                    icon="pi pi-pencil"
                                    className="p-0 border-0"
                                    text
                                    severity="help"
                                    onClick={handleEditClick}
                                />
                            )}
                        </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2 ">
                    <Table className="brandTable">
                        <tbody>
                            <tr>
                                <th className="text-start">Annual & Seasonal Campaigns <small className="d-block">(Festivals, Sales, Product Launches, etc.):</small></th>
                                <td>
                                    {CampaignPlanning?.annual_seasonal_campaigns}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Campaign Timeline Template:</th>
                                <td>
                                    {CampaignPlanning?.campaign_timeline_template}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Key Stakeholders & Approval Process:</th>
                                <td>
                                    {CampaignPlanning?.key_stakeholders_approval}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Campaign Evaluation Metrics </th>
                                <td>
                                    {CampaignPlanning?.campaign_evaluation_metrics}
                                </td>
                            </tr>

                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Edit Brand Overview"
                visible={editDialogVisible}
                style={{ width: '50vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row className="mx-0" style={{ height: '70vh', overflowY: 'auto' }}>
                    {/* Annual & Seasonal Campaigns */}
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>
                            Annual & Seasonal Campaigns <sub>(Festivals, Sales, Product Launches, etc.)</sub>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            name="annual_seasonal_campaigns"
                            value={CampaignPlanning.annual_seasonal_campaigns}
                            onChange={handleCampaignPlanningChange}
                            rows={4}
                            className="h-auto"
                        />
                    </Col>

                    {/* Campaign Timeline Template */}
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Campaign Timeline Template</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="campaign_timeline_template"
                            value={CampaignPlanning.campaign_timeline_template}
                            onChange={handleCampaignPlanningChange}
                            rows={4}
                            className="h-auto"
                        />
                    </Col>

                    {/* Key Stakeholders & Approval Process */}
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Key Stakeholders & Approval Process</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="key_stakeholders_approval"
                            value={CampaignPlanning.key_stakeholders_approval}
                            onChange={handleCampaignPlanningChange}
                            rows={4}
                            className="h-auto"
                        />
                    </Col>

                    {/* Campaign Evaluation Metrics */}
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Campaign Evaluation Metrics</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="campaign_evaluation_metrics"
                            value={CampaignPlanning.campaign_evaluation_metrics}
                            onChange={handleCampaignPlanningChange}
                            rows={4}
                            className="h-auto"
                        />
                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default CampaignPlanning
